import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BehaviorsModule } from '@ddv/behaviors';
import { CommonComponentsModule, LoaderComponent } from '@ddv/common-components';
import {
    DashboardExportComponent,
    DashboardFiltersComponent,
    DashboardHeaderNameComponent,
    DashboardsModule,
    EditDashboardNoteDropdownComponent,
    RefreshRestoreComponent,
    UserPreferenceComponent,
    ViewDashboardNoteDropdownComponent,
} from '@ddv/dashboards';
import { EntitlementsModule } from '@ddv/entitlements';
import { HttpModule } from '@ddv/http';
import { LayoutModule } from '@ddv/layout';
import { InitializationErrorsComponent } from '@ddv/navigation';
import { SocketModule } from '@ddv/socket';
import { LibSvgIconsModule } from '@ddv/svg-icons';
import { WidgetsModule } from '@ddv/widgets';
import { AdditionalFiltersComponent } from '@hs/ui-core-additional-filters';
import { SingleSelectDropdownComponent } from '@hs/ui-core-dropdowns';
import { ButtonComponent, CheckboxComponent, OptionToggleComponent, TextareaComponent, TextInputComponent } from '@hs/ui-core-inputs';
import { ModalDirective } from '@hs/ui-core-layout';
import { IconComponent } from '@hs/ui-core-presentation';

import { DashboardBarComponent } from './components/dashboard-bar/dashboard-bar.component';
import { DashboardExportComponent as LegacyDashboardExportComponent } from './components/dashboard-export/dashboard-export.component';
import { DashboardFinderComponent } from './components/dashboard-finder-dialog/dashboard-finder.component';
import { DashboardFamilyFilter } from './components/dashboard-finder-dialog/db-family-dialog/dashboard-family.pipe';
import {
    DashboardFamilyDialogComponent,
} from './components/dashboard-finder-dialog/db-family-dialog/db-family-dialog.component';
import { DashboardNavComponent } from './components/dashboard-nav/dashboard-nav.component';
import { FindViewIconComponent } from './components/dashboard-nav/find-view-icon/find-view-icon.component';
import { FindWidgetIconComponent } from './components/dashboard-nav/find-widget-icon/find-widget-icon.component';
import { FiltersBarComponent } from './components/filters-bar/filters-bar.component';
import { UnsubscribedWidgetIconComponent } from './components/filters-bar/unsubscribed-widget-icon/unsubscribed-widget-icon.component';
import {
    HSDashboardHeaderMenuComponent,
} from './components/hs-dashboard/hs-dashboard-header-menu/hs-dashboard-header-menu.component';
import { HsDashboardComponent } from './components/hs-dashboard/hs-dashboard.component';
import { ViewEditDashboardComponent } from './components/view-edit-dashboard/view-edit-dashboard.component';
import { WidgetFilterComponent } from './components/widget-filter/widget-filter.component';
import { CanDeactivateViewEditGuard } from './services/can-deactivate-guard.service';
import { DashboardNavService } from './services/dashboard-nav.service';
import { RevertDashboardService } from './services/revert-dashboard.service';

@NgModule({
    imports: [
        BehaviorsModule,
        CommonComponentsModule,
        CommonModule,
        DashboardsModule,
        DragDropModule,
        EntitlementsModule,
        FormsModule,
        HttpModule,
        LayoutModule,
        ReactiveFormsModule,
        RouterModule,
        SocketModule,
        WidgetsModule,
        LibSvgIconsModule,
        AdditionalFiltersComponent,
        ButtonComponent,
        CheckboxComponent,
        IconComponent,
        OptionToggleComponent,
        SingleSelectDropdownComponent,
        TextareaComponent,
        TextInputComponent,
        ModalDirective,
        LoaderComponent,
        DashboardHeaderNameComponent,
        DashboardExportComponent,
        UserPreferenceComponent,
        DashboardFiltersComponent,
        WidgetFilterComponent,
        RefreshRestoreComponent,
        ViewDashboardNoteDropdownComponent,
        EditDashboardNoteDropdownComponent,
        UnsubscribedWidgetIconComponent,
        InitializationErrorsComponent,
    ],
    providers: [
        CanDeactivateViewEditGuard,
        DashboardNavService,
        RevertDashboardService,
    ],
    declarations: [
        DashboardBarComponent,
        DashboardFamilyDialogComponent,
        DashboardFamilyFilter,
        DashboardFinderComponent,
        DashboardNavComponent,
        FiltersBarComponent,
        FindViewIconComponent,
        FindWidgetIconComponent,
        HsDashboardComponent,
        HSDashboardHeaderMenuComponent,
        ViewEditDashboardComponent,
        LegacyDashboardExportComponent,
    ],
    exports: [
        ViewEditDashboardComponent,
        FiltersBarComponent,
    ],
})
export class ViewsModule {}
